import { Routes } from '@angular/router';

const title = 'Seguridad';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'usuario',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Usuarios' }] },
        loadComponent: () => import('./pages/usuario-lista/usuario-lista.component'),
      },
      /* {
        path: 'registro',
        title,
        data: { ...data, urls: [{ url: '/usuario', title: 'Usuario' }, { title: 'Nuevo usuario' }] },
        loadComponent: () => import('./pages/usuario-registro/usuario-registro.component'),
      }, */
    ],
  },
];
